module.exports = __webpack_public_path__ + "img/default.103cc6ef.png";